import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';

import { Login } from './pages/login/Login';
import { Logout } from './pages/Logout';
import { UpdateAuth } from './pages/UpdateAuth';
import { SignUp } from './pages/sign-up/SignUp';
import { AppContext } from './App';
import { LegacyVerification } from './pages/sign-up/LegacyVerification';
import { InviteLanding } from './pages/invite/InviteLanding';
import { Welcome } from './pages/welcome/Welcome';
import { CreateCompany } from './pages/create-company/CreateCompany';
import { Invite } from './pages/invite/Invite';

export const appRoutes = {
  login: {
    route: '/login',
    path: () => '/login',
    children: {
      naverCallback: {
        route: '/social-login/naver/callback',
        path: () => '/social-login/naver/callback',
      },
      appleCallback: {
        route: `/social-login/apple/callback`,
        path: () => `/social-login/apple/callback`,
      },
      googleCallback: {
        route: `/social-login/google/callback`,
        path: () => `/social-login/google/callback`,
      },
    },
  },
  welcome: {
    route: '/welcome',
    path: () => '/welcome',
  },
  inviteAccept: {
    route: '/invite-accept',
    path: () => '/invite-accept',
  },
  invite: {
    route: '/invite',
    path: () => '/invite',
  },
  inviteToken: {
    route: '/invite/:token',
    path: (token: string) => `/invite/${token}`,
  },
  signUp: {
    route: '/sign-up',
    path: () => `/sign-up`,
  },
  createCompany: {
    route: '/create-company',
    path: () => '/create-company',
  },
  legacyVerification: {
    route: '/sign-up/verified',
  },
  editPassword: {
    route: '/edit-password',
    path: () => '/edit-password',
  },
  resetPassword: {
    route: '/reset-password',
    path: () => `/reset-password`,
  },
  logout: {
    route: '/logout',
  },
  updateAuth: {
    route: '/updateAuth',
  },
};

const AppRoutes: React.FC = () => {
  const { redirect } = useContext(AppContext);

  return (
    <>
      {redirect && (
        <div className={'page-container'}>
          <Routes>
            <Route path={appRoutes.logout.route} element={<Logout />} />
            <Route path={appRoutes.login.route} element={<Login />} />
            <Route path={appRoutes.login.children.naverCallback.route} element={<Login />} />
            <Route path={appRoutes.login.children.appleCallback.route} element={<Login />} />
            <Route path={appRoutes.signUp.route} element={<SignUp />} />
            <Route path={appRoutes.welcome.route} element={<Welcome />} />
            <Route path={appRoutes.createCompany.route} element={<CreateCompany />} />
            <Route path={appRoutes.invite.route} element={<Invite />} />
            <Route path={appRoutes.inviteToken.route} element={<InviteLanding />} />
            <Route path={appRoutes.inviteAccept.route} element={<InviteLanding asAccept />} />
            <Route path={appRoutes.legacyVerification.route} element={<LegacyVerification />} />
            <Route path={appRoutes.editPassword.route} element={<Login />} />
            <Route path={appRoutes.resetPassword.route} element={<Login />} />
            <Route path={appRoutes.updateAuth.route} element={<UpdateAuth />} />
            <Route path={'/'} element={<Login />} />
            <Route path={'*'} element={<Login />} />
          </Routes>
        </div>
      )}
    </>
  );
};

export default AppRoutes;
